import React from "react";
import { isApiFileUrl, resolveFileUrl } from "../../utils/fileUrl";

type AppVideoProps = Omit<
  React.VideoHTMLAttributes<HTMLVideoElement>,
  "src" | "poster" | "crossOrigin"
> & {
  src?: string | null;
  poster?: string | null;
};

/**
 * `<video>` wrapper that resolves /api/files/{guid} URLs and attaches
 * `crossOrigin="use-credentials"` when the resolved src points at our API.
 */
const AppVideo: React.FC<AppVideoProps> = ({ src, poster, children, ...rest }) => {
  const resolvedSrc = resolveFileUrl(src);
  const resolvedPoster = resolveFileUrl(poster);
  const crossOrigin = isApiFileUrl(resolvedSrc) ? "use-credentials" : undefined;
  return (
    <video src={resolvedSrc} poster={resolvedPoster} crossOrigin={crossOrigin} {...rest}>
      {children}
    </video>
  );
};

export default AppVideo;
